import {Component, Input, OnInit} from '@angular/core';
import {Log} from 'ng2-logger';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {PartNumber} from '@app/shared/models/partNumber.model';
import {PartNumberRelated} from "@models/partNumberRelated.model";

@Component({
    selector: 'app-part-number-details-form',
    templateUrl: './part-number-details-form.component.html',
    styleUrls: ['./part-number-details-form.component.scss']
})
export class PartNumberDetailsFormComponent implements OnInit {
    _logger = Log.create(PartNumberDetailsFormComponent.name)

    @Input() showValidations = false;
    @Input() mode: string;

    public detailsForm: UntypedFormGroup;
    public partNumber: PartNumber;
    public allExistingPartNumbers: PartNumber [];
    public relatedPNs: PartNumberRelated[];


    get isFormValid() {
        return this.detailsForm.valid;
    }

    constructor() {
    }

    ngOnInit() {
        this._logger.info("ngOnInit:: Preparing part number details form");
        this.detailsForm = new UntypedFormGroup({
            'id': new UntypedFormControl(''),
            'name': new UntypedFormControl('', Validators.required),
            'description': new UntypedFormControl('', Validators.required),
            'sapGroup': new UntypedFormControl('', Validators.required),
            'sapFamily': new UntypedFormControl('', Validators.required),
            'valueStream': new UntypedFormControl(''),
            'idMMDM': new UntypedFormControl(''),
            'type': new UntypedFormControl(''),
            'ecam': new UntypedFormControl(''),
            'ecamVersion': new UntypedFormControl(''),
            'bomStatus': new UntypedFormControl(''),
            'basePartNumber': new UntypedFormControl('')
        });
    }

    public init(partNumber: PartNumber, allExistingPartNumbers) {
        if (partNumber) {
            this.partNumber = partNumber;
            this.allExistingPartNumbers = allExistingPartNumbers;
            this.loadFormValue();
        }
    }

    public getFormDetails() {
        this._logger.info("getFormDetails::", this.partNumber);
        return this.detailsForm.getRawValue();
    }

    isEditMode() {
        return this.partNumber && this.mode === 'edit';
    }

    isViewMode() {
        return this.partNumber && this.mode === 'view';
    }


    isDisabled() {
        return (this.partNumber && this.partNumber.idMMDM && this.mode === 'edit') || this.mode === 'view';
    }

    showRelatedPNs() {
        return this.isEditMode() || this.isViewMode();
    }

    isNotConfigured() {
        return this.partNumber.status === 0;
    }

    onSelectBasePn(selectedPN) {
        if (selectedPN && selectedPN.id) {
            this.detailsForm.get('description').setValue(selectedPN.description);
        }
    }

    public resetForm() {
        this._logger.info("resetForm:: Resetting part number details form", this.partNumber);
        this.detailsForm.reset();
    }

    private loadFormValue() {
        if (!this.partNumber) {
            return;
        }

        const {
            id, name, description, sapGroup, sapFamily, valueStream,
            idMMDM, type, ecam, ecamVersion, bomStatus
        } = this.partNumber;
        if (this.partNumber && this.partNumber.id === 0) {
            this.partNumber = null;
        }
        const basePartNumber = '';
        this.relatedPNs = this.partNumber ? this.partNumber.relatedPartNumbers : [];
        this.detailsForm.setValue({
            id, name, description, sapGroup, sapFamily, valueStream, idMMDM, type, ecam,
            ecamVersion, bomStatus, basePartNumber
        });
    }

}
